import { cn } from "../utils/cn";

type CheckboxProps = {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  state?: "default" | "hover" | "active" | "focus" | "disabled";
};

export function Checkbox({ label, checked, onChange, state = "default" }: CheckboxProps) {
  const stateClasses =
    state === "hover"
      ? "ring-1 ring-border"
      : state === "active"
        ? "ring-1 ring-border"
        : state === "focus"
          ? "outline outline-2 outline-primary/40 outline-offset-2"
          : "";
  const disabled = state === "disabled";
  const isControlled = checked !== undefined;
  return (
    <label className={cn("inline-flex items-center gap-2 text-sm", disabled && "opacity-50")}>
      <input
        type="checkbox"
        {...(isControlled ? { checked } : {})}
        disabled={disabled}
        readOnly={!onChange && isControlled}
        className={cn("h-4 w-4 accent-primary", stateClasses)}
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <span className="text-text">{label}</span>
    </label>
  );
}
